// load global styles
import "@/styles/main.css";
import "swiper/swiper-bundle.min.css";

import throttle from "lodash/throttle";
import { sm, md } from "./breakpoints";
import "./polyfill";

//import "@/blocks / Text";

import Anchor from "@/components/Anchor";
import CookieBanner from "@/components/CookieBanner";
import "@/components/Footer";

// Blocks
import Button from "@/blocks/Button";
import "@/blocks/Badge";
import "@/blocks/Heading";
import "@/blocks/SubHeading";
import "@/blocks/Paragraph";
import "@/blocks/Image";
import "@/blocks/Video";
import "@/blocks/Link";
import "@/blocks/CustomLink";
import "@/blocks/List";
import "@/blocks/Quote";
import "@/blocks/Separator";
import "@/blocks/Gallery";
import "@/blocks/Title";
import "@/blocks/Caption";
import "@/blocks/Metrics";

// Components
import Header from "@/components/Header";
import Footer from "@/components/Footer";

// Atoms
import Pagination from "@/components/Atoms/Pagination";
import LogoutButton from "@/components/Atoms/LogoutButton";
import "@/components/Atoms/Icon";
import "@/components/Atoms/FooterDate";
import "@/components/Atoms/HeaderDate";
import "@/components/Atoms/GradientHero";

// Organisms

import Cookies from "@/components/Organisms/Cookies";
import Card from "@/components/Organisms/Card";
import Banner from "@/components/Organisms/Banner";
import "@/components/Organisms/SectionHeader";
import HeroMenu from "@/components/Organisms/HeroMenu";
import "@/components/Organisms/StickyImage";
import "@/components/Organisms/InfiniteText";
import ResetPassword from "@/components/Organisms/ResetPassword";
import Input from "@/components/Organisms/Input";
import NavBar from "@/components/Organisms/NavBar";
import UserMenu from "@/components/Organisms/UserMenu";
import Nav from "@/components/Organisms/Nav";
import NavLogin from "@/components/Organisms/NavLogin";
import Hero from "@/components/Organisms/Hero";
import ReadingBar from "@/components/Organisms/ReadingBar";
import Carousel from "@/components/Organisms/Carousel";
import TextCarousel from "@/components/Organisms/TextCarousel";
import ImageCarousel from "@/components/Organisms/ImageCarousel";
import TeamMember from "@/components/Organisms/TeamMember";
import MemberSubscription from "@/components/Organisms/MemberSubscription";
import StickyCallout from "@/components/Organisms/StickyCallout";
import Profile from "@/components/Organisms/Profile";

// Layouts
import LayoutCards from "@/components/Layouts/Cards";
import LayoutCarosel from "@/components/Layouts/Carousel";
import "@/components/Layouts/TextCarousel";
import "@/components/Layouts/ImageCarousel";
import "@/components/Layouts/ArticleHeader";
import "@/components/Layouts/InfiniteText";
import "@/components/Layouts/Page404";
import Team from "@/components/Layouts/Team";

// Utils
import "@/components/Utils/Container";

import {
  addClassTransition,
  removeClassTransition,
} from "@/utils/classTransition";

const MODULES = [CookieBanner];

const MODALS = {
  // language: LanguageModal,
  // agenda: AgendaModal,
};

const MAIN_MODULES = {
  Header,
  Footer,
  Button,
  Banner,
  Cookies,
  Card,
  Pagination,
  UserMenu,
  Nav,
  NavBar,
  NavLogin,
  Hero,
  HeroMenu,
  Input,
  Carousel,
  ResetPassword,
  LayoutCards,
  LayoutCarosel,
  ReadingBar,
  StickyCallout,
  Profile,
  ImageCarousel,
  TextCarousel,
  TeamMember,
  MemberSubscription,
  LogoutButton,
  Team,
};

const SERVICES = {
  // theFirebaseManager: FirebaseManager,
};

export const getInstance = (el) => {
  const instanceIndex = el.getAttribute("data-instance-index");

  if (!instanceIndex) {
    return null;
  }

  return window.App.instances[parseInt(instanceIndex, 10)];
};

class App {
  lastIndex = 0;

  constructor() {
    window.addEventListener("DOMContentLoaded", this.initApp);
    window.addEventListener("resize", throttle(this.onResize, 150));
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("popstate", this.onPopState);
  }

  initApp = () => {
    this.lastIndex = 0;
    this.currentView = this.getCurrentView();

    this.instances = [];
    this.modals = {};

    const main = document.querySelector("#main");
    if (main) {
      history.replaceState(
        {
          title: document.title,
          main: main.innerHTML,
          bodyClassAttribute: document.body.getAttribute("class"),
        },
        document.title,
        window.location.href
      );
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    this.initArea(document);
  };

  initArea = (parentElement) => {
    if (!parentElement) {
      return [];
    }

    // Create module instances
    const newInstances = MODULES.filter((module) =>
      module.hasOwnProperty("selector")
    ).flatMap((Module) => {
      const blocks = [...parentElement.querySelectorAll(Module.selector)];
      return blocks
        .filter((block) => !block.getAttribute("data-instance-index"))
        .map((block) => {
          block.setAttribute("data-instance-index", this.lastIndex);

          this.lastIndex++;
          return new Module(block);
        });
    });

    // Create modals instances
    Object.keys(MODALS).forEach((k) => {
      const Modal = MODALS[k];

      if (!Modal.hasOwnProperty("selector")) {
        return;
      }

      const block = parentElement.querySelector(Modal.selector);
      if (!block) {
        return;
      }

      if (block.getAttribute("data-instance-index")) {
        return;
      }

      block.setAttribute("data-instance-index", this.lastIndex);
      this.lastIndex++;

      this.modals[k] = new Modal(block);

      newInstances.push(this.modals[k]);
    });

    // Create main module instances
    Object.keys(MAIN_MODULES).forEach((k) => {
      const Module = MAIN_MODULES[k];

      if (!Module.hasOwnProperty("selector")) {
        return;
      }

      /*
      const block = parentElement.querySelector(Module.selector);

      if (!block) {
        return;
      }

      if (block.getAttribute("data-instance-index")) {
        return;
      }

      block.setAttribute("data-instance-index", this.lastIndex);
      this.lastIndex++;

      this[k] = new Module(block);

      newInstances.push(this[k]);

      */

      // Extends the module init to all modules
      const blocks = parentElement.querySelectorAll(Module.selector);
      if (!blocks || !blocks.length) {
        return;
      }

      blocks.forEach((block) => {
        if (!block.getAttribute("data-instance-index")) {
          block.setAttribute("data-instance-index", this.lastIndex);
          this.lastIndex++;
          this[k] = new Module(block);

          newInstances.push(this[k]);
        }
      });
    });

    // Create services instances
    Object.keys(SERVICES).forEach((k) => {
      if (this[k]) {
        // Services can only be initialised once and cannot be destroyed
        return;
      }

      const Module = SERVICES[k];

      this.lastIndex++;

      this[k] = new Module();

      newInstances.push(this[k]);
    });

    // Call onReady method if any

    newInstances.forEach((instance) => {
      if (instance.onReady) {
        instance.onReady();
      }
    });

    // Call onComplete method if any
    newInstances.forEach((instance) => {
      if (instance.onComplete) {
        instance.onComplete();
      }
    });

    this.instances = this.instances.concat(newInstances);

    return newInstances;
  };

  destroyArea = (parentElement, keep = []) => {
    [...parentElement.children].forEach((element) => {
      // Skip destroy if element is in `keep`
      if (keep.some((s) => element.matches && element.matches(s))) {
        return;
      }

      // If this element has an instance attached
      if (element.getAttribute("data-instance-index")) {
        // Get instance
        const instance = getInstance(element);

        // Call onDestroy method if any
        if (instance.onDestroy) {
          instance.onDestroy();
        }

        // Remove instance references
        this.instances[parseInt(element.dataset.instanceIndex, 10)] = null;
        Object.keys(MAIN_MODULES).forEach((k) => {
          if (this[k] === instance) {
            this[k] = null;
          }
        });
        Object.keys(MODALS).forEach((k) => {
          if (this.modals[k] === instance) {
            this.modals[k] = null;
          }
        });
      }

      element.remove();
    });
  };

  loadUrl = async (url) => {
    return new Promise(async (resolve) => {
      const response = await fetch(url, {
        credentials: "include",
      });
      const html = await response.text();
      resolve(html);
    });
  };

  navigateTo = async (url, _replaceSelectors = ["#main"], opts = {}) => {
    const replaceSelectors = Array.isArray(_replaceSelectors)
      ? _replaceSelectors
      : [_replaceSelectors];

    const options = {
      keep: [],
      exitTransition: null,
      enterTransition: null,
      doScroll: true,
      ...opts,
    };

    // Async request
    const response = await fetch(url, {
      credentials: "include",
    });
    const html = await response.text();

    // Parse html received
    const parser = new DOMParser();
    const receivedDocument = parser.parseFromString(html, "text/html");

    // Copy content to
    const to = {};
    replaceSelectors.forEach((s) => (to[s] = document.querySelector(s)));

    const replaceableElements = Object.keys(to);

    if (!replaceableElements.length) {
      // There is nothing to replace
      return;
    }

    // Copy content from
    const from = {};
    replaceSelectors.forEach(
      (s) => (from[s] = receivedDocument.querySelector(s))
    );

    // Exit transition
    if (options.exitTransition) {
      await options.exitTransition();
    } else {
      const exitPromises = replaceableElements.map((k) =>
        addClassTransition(to[k], "hidden", {
          awaitForProperty: "opacity",
          timeout: 400,
        })
      );

      // Wait all the exiting in parallel
      await Promise.all(exitPromises);
    }

    // Dstroy deleted content

    this.instances.forEach((instance) => {
      if (instance && instance.onDestroy) {
        instance.onDestroy();
      }
    });

    replaceableElements.forEach((k) => this.destroyArea(to[k], options.keep));

    // Update history
    history.pushState(
      {
        title: receivedDocument.title,
        main: receivedDocument.querySelector("#main").innerHTML,
        bodyClassAttribute: receivedDocument.body.getAttribute("class"),
      },
      receivedDocument.title,
      response.url
    );

    if (window.fbq) {
      fbq("track", "PageView");
    }

    // Update title
    document.title = receivedDocument.title;

    // Get new content
    replaceableElements.forEach((k) => {
      if (!from[k]) {
        return;
      }

      while (from[k].childNodes.length > 0) {
        if (
          options.keep.some(
            (s) =>
              from[k].childNodes[0].matches && from[k].childNodes[0].matches(s)
          )
        ) {
          // If the head element is kept from previous content, just remove this
          // from the new content list and go ahead in the while
          from[k].childNodes[0].remove();
        } else {
          // If the head element is not kept from previous content, just detach
          // this from the new content list and append it to destination container
          // (`to`)
          to[k].appendChild(from[k].childNodes[0]);
        }
      }
    });

    if (options.doScroll) {
      // Scroll top
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    // Get new body classes
    document.body.setAttribute(
      "class",
      receivedDocument.body.getAttribute("class")
    );

    // Enter transition
    if (options.enterTransition) {
      await options.enterTransition();
    } else {
      const enteringPromises = replaceableElements.map((k) =>
        removeClassTransition(to[k], "hidden", {
          awaitForProperty: "opacity",
          timeout: 400,
        })
      );

      // Wait all the entering in parallel
      await Promise.all(enteringPromises);
    }

    // Initialize new content
    replaceableElements.forEach((k) => this.initArea(to[k]));

    if (window.gtag && window.wpData.gtagMeasurementId) {
      gtag("config", window.wpData.gtagMeasurementId, {
        page_path: window.location.pathname,
      });
    }

    window.__refresh && window.__refresh();
  };

  onResize = (e) => {
    if (!this.instances) {
      return;
    }

    const currentView = this.getCurrentView();
    const changedView = this.currentView !== currentView;

    this.currentView = currentView;

    this.instances.forEach((instance) => {
      if (instance.onResize) {
        instance.onResize(e, {
          changedView,
        });
      }
    });
  };

  getCurrentView() {
    const isTablet = window.innerWidth >= sm;
    const isLaptop = window.innerWidth >= md;

    if (isLaptop) {
      return "laptop";
    }

    if (isTablet) {
      return "tablet";
    }

    return "mobile";
  }

  onScroll = (e) => {
    if (!this.instances) {
      return;
    }

    this.instances.forEach((instance) => {
      if (instance && instance.onScroll) {
        instance && instance.onScroll({ y: window.scrollY });
      }
    });
  };

  onPopState = async (e) => {
    if (e.state !== null) {
      if ("main" in e.state) {
        const fromString = e.state.main;
        const to = document.querySelector("#main");

        // Exit transition
        await addClassTransition(to, "hidden", {
          awaitForProperty: "opacity",
          timeout: 400,
        });

        // destroy deleted content
        this.destroyArea(to);

        document.title = e.state.title;

        // Get new content
        to.innerHTML = fromString;

        // Scroll top
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });

        // Get new body classes
        document.body.setAttribute("class", e.state.bodyClassAttribute);

        // Enter transition
        await removeClassTransition(to, "hidden", {
          awaitForProperty: "opacity",
          timeout: 400,
        });

        // Initialize new content
        this.initArea(to);
      }
    }
  };
}

window.App = new App();
